import { render, staticRenderFns } from "./ProfileTemplate.vue?vue&type=template&id=6c81abdc&lang=pug"
import script from "./ProfileTemplate.vue?vue&type=script&lang=ts"
export * from "./ProfileTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ProfileTemplate.vue?vue&type=style&index=0&id=6c81abdc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports